import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";

import backend from "../../../backend";
import useIsMobile from "../../../hooks/useIsMobile";

const PricesPanel = () => {
  const isMobile = useIsMobile();
  const [prices, setPrices]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const constants = (await backend.get("constants/machineType")).data;
        if (!cancelled) setPrices(constants.prices || []);
      } catch (err) {
        console.log(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const setValue = (k, v, i) => {
    const newPrices = [...prices];
    newPrices[i][k] = v;
    setPrices(newPrices);
  };

  const setNumber = (v, set) => {
    v = v.replace(/[^0-9]/g, "");
    set(v);
  };

  const submit = async () => {
    setMsg(null);
    for (const p of prices) {
      if (p.price === "" || p.priceField === "" || p.priceMinimal === "") {
        setMsg({ ok: false, text: "Faltan campos por completar" });
        return;
      }
    }
    setSaving(true);
    try {
      await backend.patch("constants/prices", { prices });
      setMsg({ ok: true, text: "Precios guardados" });
    } catch (err) {
      setMsg({ ok: false, text: "Error: " + (err?.response?.data?.error || err.message) });
    }
    setSaving(false);
  };

  if (loading) {
    return <div style={{ color: "#cbd5e1", fontSize: 12 }}>Cargando…</div>;
  }

  return (
    <div>
      <div style={{
        fontSize: 12, fontWeight: 700, color: "#999",
        textTransform: "uppercase", letterSpacing: ".07em",
        margin: "0 0 10px",
      }}>
        Precios por hora de máquina
      </div>

      {/* En móvil la grilla de 4 columnas no cabe: una tarjeta por tipo de
          máquina con sus 3 precios etiquetados. Mismos handlers, solo layout. */}
      {isMobile ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {prices.map((v, i) => (
            <div key={i} style={{
              background: "#242424", border: "1px solid #2e2e2e",
              borderRadius: 12, padding: 14,
            }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#fff", marginBottom: 10 }}>
                {v.machineType?.type}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {[
                  ["General", "price", v.price],
                  ["Area Específica", "priceField", v.priceField],
                  ["Valor Mínima", "priceMinimal", v.priceMinimal],
                ].map(([label, key, val]) => (
                  <div key={key}>
                    <div style={{
                      fontSize: 10, fontWeight: 700, color: "#8a8a8a",
                      textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 4,
                    }}>{label}</div>
                    <Form.Control
                      onChange={e => setNumber(e.target.value, p => setValue(key, p, i))}
                      value={val}
                      required
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
      <div
        className="grid"
        style={{
          gridTemplateColumns: "auto 200px 200px 200px",
          columnGap: 12,
          rowGap: 12,
          maxWidth: 760,
          alignItems: "center",
        }}
      >
        <div />
        <div style={{ fontSize: 10, color: "#cbd5e1", textTransform: "uppercase" }}>General</div>
        <div style={{ fontSize: 10, color: "#cbd5e1", textTransform: "uppercase" }}>Area Específica</div>
        <div style={{ fontSize: 10, color: "#cbd5e1", textTransform: "uppercase" }}>Valor Mínima</div>

        {prices.map((v, i) => (
          <React.Fragment key={i}>
            <div style={{ color: "#ddd", fontSize: 12 }}>{v.machineType?.type}</div>
            <Form.Group>
              <Form.Control
                onChange={e => setNumber(e.target.value, p => setValue("price", p, i))}
                value={v.price}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                onChange={e => setNumber(e.target.value, p => setValue("priceField", p, i))}
                value={v.priceField}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Control
                onChange={e => setNumber(e.target.value, p => setValue("priceMinimal", p, i))}
                value={v.priceMinimal}
                required
              />
            </Form.Group>
          </React.Fragment>
        ))}
      </div>
      )}

      {msg && (
        <div style={{
          marginTop: 14, fontSize: 11, padding: "7px 10px", borderRadius: 5, maxWidth: 760,
          background: msg.ok ? "#0d2a15" : "#2d1515",
          color: msg.ok ? "#2ecc71" : "#e74c3c",
          border: `1px solid ${msg.ok ? "#0d4020" : "#4a2020"}`,
        }}>{msg.text}</div>
      )}

      <div style={{ marginTop: 16, maxWidth: 760, display: "flex", justifyContent: "flex-end" }}>
        <button
          className="bini-btn bini-btn-save"
          onClick={submit}
          disabled={saving}
        >
          {saving ? "Guardando…" : "Guardar precios"}
        </button>
      </div>
    </div>
  );
};

export default PricesPanel;
